import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Portfolio from "./pages/Portfolio";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import "nprogress/nprogress.css";   // default styles
import "./nprogress-custom.css";    // custom overrides

function App() {
  // Global theme initializer (Locked to Light Mode)
  useEffect(() => {
    document.documentElement.classList.remove("dark");
    localStorage.setItem("theme", "light");
  }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900 transition-colors duration-500">
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/*" element={<AdminDashboard />} />
      </Routes>
    </div>
  );
}

export default App;
